<template>
  <div class="product-form-container">
    <!-- 全局加载遮罩层 只读模式移除 -->
    <!-- 表单主体 -->
    <div class="form-wrapper">
      <!-- 左侧表单区域 -->
      <div class="form-left">
        <!-- 样衣编号 -->
        <div class="form-item single-item">
          <label>样衣编号:</label>
          <input type="text" v-model="formData.productCode" disabled />
          <label>类别:</label>
          <el-tooltip :content="formData.lb" placement="top">
            <input type="text" v-model="formData.lb" disabled />
          </el-tooltip>
        </div>
        <!-- 面料信息分组 -->
        <div class="fabric-group">
          <div class="group-title">面料信息：</div>
          <!-- 品名/编号（单独一行） -->
          <div class="form-item single-item">
            <label>品名/编号:</label>
            <input type="text" v-model="formData.productpm" disabled />
          </div>
          <!-- 两行两列布局：幅宽/克重、成份/类别 -->
          <div class="form-row">
            <div class="form-item">
              <label>幅宽:</label>
              <input type="text" v-model="formData.width" disabled />
            </div>
            <div class="form-item">
              <label>克重:</label>
              <input type="text" v-model="formData.weight" disabled />
            </div>
          </div>
          <div class="form-row">
            <div class="form-item">
              <label>成份:</label>
              <input type="text" v-model="formData.composition" disabled />
            </div>
            <div class="form-item">
              <label>面料类别:</label>
              <el-tooltip :content="formData.text" placement="top">
                <input type="text" v-model="formData.text" disabled />
              </el-tooltip>
            </div>
          </div>
          <div class="form-row">
            <div class="form-item">
              <label>量化:</label>
              <input type="text" v-model="formData.quantify" disabled />
            </div>
            <div class="form-item">
              <label>备注:</label>
              <input type="text" v-model="formData.remark" disabled />
            </div>
          </div>
          <div class="form-row">
            <div class="form-item">
              <label>纱支:</label>
              <input type="text" v-model="formData.yarnCount" disabled />
            </div>
            <div class="form-item">
              <label>密度:</label>
              <input type="text" v-model="formData.density" disabled />
            </div>
          </div>
          <div class="form-row">
            <div class="form-item">
              <label>规格:</label>
              <input type="text" v-model="formData.specification" disabled />
            </div>
          </div>
        </div>
      </div>
      <!-- 右侧图片展示区域（只读，无上传删除） -->
      <div class="form-right">
        <!-- 封面图 -->
        <div class="upload-section">
          <h4>封面图</h4>
          <div class="upload-boxes">
            <div
              class="upload-box"
              v-if="previewUrls['cover-1']"
              @click="openImagePreview(previewUrls['cover-1'])"
            >
              <img :src="previewUrls['cover-1']" class="uploaded-img" />
            </div>
            <div v-else class="empty-tip">暂无封面图</div>
          </div>
        </div>
        <!-- 详情图 -->
        <div class="upload-section">
          <h4>详情图</h4>
          <div class="upload-container">
            <div class="img-show-wrap">
              <div
                class="upload-box img-item"
                v-for="item in validDetails"
                :key="`detail-${item.sort}-${item.id}`"
                @click="openImagePreview(item.url)"
              >
                <img :src="item.url" class="uploaded-img" />
              </div>
              <div v-if="validDetails.length === 0" class="empty-tip">
                暂无详情图
              </div>
            </div>
          </div>
        </div>
        <!-- 电子色卡 -->
        <div class="upload-section">
          <h4>电子色卡</h4>
          <div class="upload-container">
            <div class="img-show-wrap">
              <div
                class="upload-box img-item"
                v-for="item in validColors"
                :key="`color-${item.sort}-${item.id}`"
                @click="openImagePreview(item.url)"
              >
                <img :src="item.url" class="uploaded-img" />
              </div>
              <div v-if="validColors.length === 0" class="empty-tip">
                暂无电子色卡
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 标题和正文输入区 只读 -->
      <div class="textarea-section">
        <div class="textarea-item">
          <label>标题</label>
          <textarea
            v-model="formData.title"
            placeholder="无标题"
            disabled
          ></textarea>
        </div>
        <div class="textarea-item">
          <label>正文</label>
          <textarea
            v-model="formData.content"
            placeholder="无正文"
            rows="6"
            disabled
          ></textarea>
        </div>
      </div>
    </div>
    <!-- ========== Element Plus 官方图片预览组件 ========== -->
    <el-image-viewer
      v-if="previewVisible"
      :url-list="previewImgList"
      :initial-index="previewIndex"
      @close="closeImagePreview"
      hide-on-click-modal
    />
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
import {
  ref,
  reactive,
  computed,
  watch,
  onMounted,
  getCurrentInstance,
} from "vue";
const { proxy } = getCurrentInstance();

const props = defineProps({
  row: { type: Object, required: true, default: () => ({}) },
});

const leilist = ref([]);
const localRow = ref({});
const formData = reactive({
  text: "",
  quantify: "",
  remark: "",
  lb: "",
  id: "",
  productCode: "",
  width: "",
  weight: "",
  composition: "",
  title: "",
  content: "",
  productpm: "",
  specification: "",
  yarnCount: "",
  density: "",
});
const previewUrls = ref({});
const details = ref([]);
const colors = ref([]);
const previewVisible = ref(false);
const previewImgList = ref([]);
const previewIndex = ref(0);
const texts = ref("");

const validDetails = computed(() => {
  return details.value.filter((item) => !item.deleted);
});
const validColors = computed(() => {
  return colors.value.filter((item) => !item.deleted);
});

// 补全图片URL协议
const completeUrlProtocol = (url) => {
  if (!url || typeof url !== "string") return "";
  if (!url.startsWith("http://") && !url.startsWith("https://")) {
    return `https://${url}`;
  }
  return url;
};

// 获取分类列表
const getCategoryList = async () => {
  try {
    const res = await proxy.$api.System.ProductCategory.get({});
    if (res.data.code == 200 && Array.isArray(res.data.data?.list)) {
      leilist.value = res.data.data.list.map((item) => ({
        id: item.id,
        name: item.name,
      }));
    }
  } catch (error) {
    console.error("获取类别列表失败：", error);
  }
};

// 初始化展示数据
const initEditData = () => {
  const d = props.row;
  if (!d) return;
  if (d?.fabricCategoryList) {
    let text = "";
    for (let index = 0; index < d.fabricCategoryList.length; index++) {
      text += d.fabricCategoryList[index].name + ",";
    }
    if (text) {
      text = text.slice(0, -1);
    }
    console.log(text, "最终返回的数字");
    texts.value = text;
  } else {
    texts.value = "";
  }
  localRow.value = JSON.parse(JSON.stringify(d));
  // 详情图
  details.value = (localRow.value.particularsList || []).map((item) => ({
    id: item.id,
    sort: item.sort,
    url: completeUrlProtocol(item.url),
    deleted: false,
  }));
  // 色卡图
  colors.value = (localRow.value.colorcardList || []).map((item) => ({
    id: item.id,
    sort: item.sort,
    url: completeUrlProtocol(item.url),
    deleted: false,
  }));
  // 基础表单
  formData.id = d.id || "";
  formData.productCode = d.outerKey || "";
  formData.width = d.width || "";
  formData.weight = d.weight || "";
  formData.composition = d.ingredients || "";
  formData.title = d.title || "";
  formData.content = d.content || "";
  formData.productpm = d.name || "";
  formData.lb = d.categoryNames;
  formData.remark = d?.remark || "";
  formData.quantify = d?.quantify || "";
  formData.text = texts.value || "";
  formData.yarnCount = d.yarnCount || "";
  formData.density = d.density || "";
  formData.specification = d.specification || "";
  // 封面图
  if (d.coverUrl) {
    previewUrls.value["cover-1"] = completeUrlProtocol(d.coverUrl);
  }
};

// 打开大图预览：收集全部图片，找到当前点击索引，打开element预览器
const openImagePreview = (clickImgUrl) => {
  // 合并：封面 + 详情 + 色卡 全部图片到预览列表，支持左右切换
  const allImg = [];
  if (previewUrls.value["cover-1"]) allImg.push(previewUrls.value["cover-1"]);
  validDetails.value.forEach((item) => allImg.push(item.url));
  validColors.value.forEach((item) => allImg.push(item.url));
  previewImgList.value = allImg;
  previewIndex.value = allImg.findIndex((url) => url === clickImgUrl);
  previewVisible.value = true;
};

// 关闭大图预览
const closeImagePreview = () => {
  previewVisible.value = false;
  previewImgList.value = [];
  previewIndex.value = 0;
};

// 重置
const resetForm = () => {
  formData.id = "";
  formData.productCode = "";
  formData.width = "";
  formData.weight = "";
  formData.composition = "";
  formData.title = "";
  formData.content = "";
  formData.productpm = "";
  formData.yarnCount = "";
  formData.density = "";
  formData.specification = "";
  details.value = [];
  colors.value = [];
  previewUrls.value = {};
  localRow.value = {};
  previewVisible.value = false;
  previewImgList.value = [];
  previewIndex.value = 0;
};

// 监听props.row
watch(
  () => props.row,
  (n) => {
    if (n && n.id) {
      resetForm();
      initEditData();
    }
  },
  { deep: true, immediate: true }
);

onMounted(() => {
  getCategoryList().then(() => initEditData());
});
</script>

<style lang="scss" scoped>
@import "./user-product-launch.scss";
.form-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  label {
    width: 74px;
    text-align: right;
    margin-right: 10px;
    font-size: 14px;
    color: #333;
    flex-shrink: 0;
  }
  input,
  textarea,
  :deep(.el-select) {
    height: 32px;
    padding: 0 8px;
    border: none;
    border-bottom: 1px solid #999;
    border-radius: 4px;
    font-size: 14px;
    background: #fff !important;
    color: #666;
    cursor: default;
  }
  input:disabled,
  textarea:disabled {
    color: #666;
    background-color: #fff !important;
  }
}
.single-item {
  width: 100%;
}
.fabric-group {
  margin-top: 56px;
  .group-title {
    font-size: 14px;
    color: #333;
    margin-bottom: 10px;
    font-weight: normal;
  }
}
.form-row {
  display: flex;
  .form-item {
    flex: 1;
    margin-bottom: 15px;
  }
}
.upload-box {
  width: 100px;
  height: 100px;
  border: 1px solid #eee;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
  cursor: zoom-in;
  background: #f8f8f8;
  .uploaded-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.empty-tip {
  color: #999;
  font-size: 13px;
  padding: 20px 0;
}
:deep(.el-select .el-input__inner) {
  background-color: #fff !important;
}
.btn-group {
  margin-top: 30px;
  text-align: center;
  .btn {
    padding: 8px 22px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
  }
  .save-btn {
    background: #999;
    color: #fff;
  }
}
</style>
